@if (isNaNc) {
    @for (answer of question.ResultClass.ResultClassValues.Values; track answer.ID) {
        @if (answer.ID < 0) {
            <button [disabled]="isLocked()"
                    class="flex h-10 min-w-24 justify-center rounded-full sm:h-8 sm:rounded-2xl"
                    [class]="{'!bg-button-active': (question.UserAnswer && question.UserAnswer.ResultClassValueID &&
                    question.UserAnswer.ResultClassValueID == answer.ID),
                    '!text-default':(question.UserAnswer && question.UserAnswer.ResultClassValueID &&
                    question.UserAnswer.ResultClassValueID == answer.ID),
                    'bg-button/80': answerIsNull,
                    'text-default/80': answerIsNull,
                    'bg-button/20 ': !answerIsNull,
                    'text-default/60': !answerIsNull}"
                    (click)="singleChoiceSelection([answer])">
                {{ answer.Value }}
            </button>
        }
    }
} @else {
    @if (isMobileView && question.ResultClass.ResultClassValues.Values.length > 6) {
        <div class="input-button-group flex w-full">
            <kendo-multiselect #multiSelectInput [readonly]="isLocked()"
                               [data]="question.ResultClass.ResultClassValues.Values"
                               class="bizz-combobox-multiselect hidden-input"
                               textField="Value" valueField="ID" [clearButton]="false"
                               [valuePrimitive]="false" [value]="selectedColor"
                               (valueChange)="singleChoiceSelection($event)">
                <ng-template kendoMultiSelectTagTemplate let-dataItem>
                    <div
                            class="flex h-5 min-w-16 items-center justify-center rounded-full align-middle"
                            [class.!bg-button]="dataItem.ID < 0"
                            [style]="{ 'background-color': dataItem.BackgroundColor }">
                    <span
                            [class.!text-default]="dataItem.ID < 0"
                            class="text-xs font-bold text-white">{{ dataItem.Value }}</span>
                    </div>
                </ng-template>
                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                    <div
                            class="flex h-5 min-w-16 items-center justify-center rounded-full px-4 align-middle"
                            [class.!bg-button]="dataItem.ID < 0"
                            [style]="{ 'background-color': dataItem.BackgroundColor }">
                    <span
                            [class.!text-default]="dataItem.ID < 0"
                            class="text-xs font-bold text-white">{{ dataItem.Value }}</span>
                    </div>
                </ng-template>
            </kendo-multiselect>
            <div class="button-group">
                <button type="button" [disabled]="isLocked()"
                        class="default !px-2 !py-1"
                        (click)="multiSelectInput.toggle()">
                    <bizz-toggle-arrow class="pointer-events-none size-4"
                                       [direction]="multiSelectInput.isOpen ? 'up' : 'down'">
                    </bizz-toggle-arrow>
                </button>
            </div>
        </div>
    } @else {
        @for (answer of question.ResultClass.ResultClassValues.Values; track answer.ID) {
            @if (answer.ID > 0) {
                @if (question.UserAnswer && question.UserAnswer.ResultClassValueID &&
                (question.UserAnswer.ResultClassValueID ==
                        answer.ID)) {

                    <button [disabled]="isLocked()"
                            class="flex h-10 min-w-24 justify-center rounded-full !text-white sm:h-8 sm:rounded-2xl"
                            [ngStyle]="{ 'background-color': answer.BackgroundColor }"
                            (click)="singleChoiceSelection([answer])">
                        {{ answer.Value }}
                    </button>
                } @else {
                    <button [disabled]="isLocked()"
                            class="flex h-10 min-w-24 justify-center rounded-full sm:h-8 sm:rounded-2xl"
                            [ngStyle]="{
                    'background-color': answer.BackgroundColor + (answerIsNull ?  '33' : (isDarkTheme ? '1a': '0d')),
                    color: isDarkTheme ? '#FFFFFFCC' : answer.ForegroundColor + (answerIsNull ?  'CC' : '99')
                }" (click)="singleChoiceSelection([answer])">
                        {{ answer.Value }}
                    </button>
                }
            } @else {
                <button [disabled]="isLocked()"
                        class="flex h-10 min-w-24 justify-center rounded-full text-default/80 sm:h-8 sm:rounded-2xl"
                        [class]="{'!bg-button-active': (question.UserAnswer && question.UserAnswer.ResultClassValueID &&
                    question.UserAnswer.ResultClassValueID == answer.ID),
                    '!text-default':(question.UserAnswer && question.UserAnswer.ResultClassValueID &&
                    question.UserAnswer.ResultClassValueID == answer.ID),
                    'bg-button/80': answerIsNull,
                    'text-default/80': answerIsNull,
                    'bg-button/20 ': !answerIsNull,
                    'text-default/60': !answerIsNull}"
                        (click)="singleChoiceSelection([answer])">
                    {{ answer.Value }}
                </button>
            }
        }
    }
}